// qbrix-static.js — JS for static pages (refund, shipping, contact)
// Loaded only on page templates (not globally) via theme.liquid conditional

// ─── Refund Page ───────────────────────────────────────────
function initRefundPage() {
  if (!document.querySelector('.rfnd-frame-wrap')) return;

  // Breadcrumbs stagger animation (10B pattern)
  document.querySelectorAll('.rfnd-breadcrumbs .crumb-anim').forEach(function(el) {
    el.classList.add('played');
  });

  // IntersectionObserver — 6B header
  var hdrObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('hdr-in-view');
        hdrObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.hdr-observe').forEach(function(el) {
    hdrObs.observe(el);
  });

  // IntersectionObserver — rfnd-reveal (scroll animations with staggered delay)
  var revealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('rfnd-in-view');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.rfnd-reveal').forEach(function(el, i) {
    el.style.transitionDelay = (i * 60) + 'ms';
    revealObs.observe(el);
  });
}

// ─── Form submit handler (refund form) ─────────────────────
function handleRfndSubmit(e) {
  e.preventDefault();
  var form = document.getElementById('rfnd-form');
  var success = document.getElementById('rfnd-success');
  if (form) form.style.display = 'none';
  if (success) success.style.display = 'block';
}

// ─── Shipping Page ──────────────────────────────────────────
function initShippingPage() {
  if (!document.querySelector('.qbrix-shipping-section')) return;

  // IntersectionObserver — hdr-observe elements (B3 headers + A2)
  var hdrObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('hdr-in-view');
        hdrObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.hdr-observe').forEach(function(el) {
    hdrObs.observe(el);
  });

  // Clone ticker for seamless marquee
  var track = document.getElementById('shp-ticker-track');
  if (track) {
    var group = track.querySelector('.shp-ticker-group');
    if (group && !track.dataset.cloned) {
      track.appendChild(group.cloneNode(true));
      track.appendChild(group.cloneNode(true));
      track.dataset.cloned = 'true';
    }
  }

  // FAQ Accordion (exact pattern from v4-final)
  document.querySelectorAll('.shp-faq-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var content = btn.nextElementSibling;
      var isOpen = content.classList.contains('faq-open');

      // Close all
      document.querySelectorAll('.faq-content').forEach(function(c) { c.classList.remove('faq-open'); });
      document.querySelectorAll('.shp-faq-btn').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        var title = b.querySelector('.faq-title');
        if (title) { title.style.color = '#9CA3AF'; }
        var icon = b.querySelector('.faq-icon');
        if (icon) { icon.style.transform = 'rotate(0deg)'; }
      });

      // Open current if was closed
      if (!isOpen) {
        content.classList.add('faq-open');
        btn.setAttribute('aria-expanded', 'true');
        var title = btn.querySelector('.faq-title');
        if (title) { title.style.color = '#fff'; }
        var icon = btn.querySelector('.faq-icon');
        if (icon) { icon.style.transform = 'rotate(45deg)'; }
      }
    });
  });

  // Floating brick confetti
  var confettiContainer = document.getElementById('shp-confetti-container');
  if (confettiContainer) {
    var brickUrls = [
      'https://qbrix.me/img/bricks/brick-e02f85.png',
      'https://qbrix.me/img/bricks/brick-f8c000.png',
      'https://qbrix.me/img/bricks/brick-b2d9c0.png',
      'https://qbrix.me/img/bricks/brick-4a275d.png',
      'https://qbrix.me/img/bricks/brick-1a2642.png',
    ];
    var numBricks = window.innerWidth < 768 ? 15 : 28;

    for (var i = 0; i < numBricks; i++) {
      var img = document.createElement('img');
      var size = Math.random() * 16 + 14;
      var url  = brickUrls[Math.floor(Math.random() * brickUrls.length)];

      img.className = 'shp-confetti';
      img.src = url;
      img.alt = '';
      img.style.width  = size + 'px';
      img.style.height = size + 'px';
      img.style.objectFit = 'contain';

      var left      = Math.random() * 100;
      var startDelay = Math.random() * 5;
      var duration  = Math.random() * 10 + 10;

      img.style.left      = left + '%';
      img.style.bottom    = '-50px';
      img.style.animation = 'shp-float-up ' + duration + 's linear ' + startDelay + 's infinite';

      confettiContainer.appendChild(img);
    }
  }
}

// ─── Contact Page ───────────────────────────────────────────
function initContactPage() {
  if (!document.querySelector('.qbrix-contact-section')) return;

  // Breadcrumbs build-in animation (10B pattern)
  var bcNav = document.getElementById('ctc-breadcrumb');
  if (bcNav) {
    var obsBC = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        bcNav.querySelectorAll('.crumb-anim').forEach(function(el, i) {
          el.style.animationDelay = (i * 0.15) + 's';
          el.classList.add('played');
        });
        obsBC.disconnect();
      }
    }, { threshold: 0.1 });
    obsBC.observe(bcNav);
  }

  // IntersectionObserver — hdr-observe elements (B3 headers)
  var hdrObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('hdr-in-view');
        hdrObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('.qbrix-contact-section .hdr-observe').forEach(function(el) {
    hdrObs.observe(el);
  });

  // IntersectionObserver — ctc-fade-up elements
  var fadeObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        fadeObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.ctc-fade-up').forEach(function(el) {
    fadeObs.observe(el);
  });

  // WA card hover enhancement
  var waCard = document.querySelector('.ctc-wa-card');
  if (waCard) {
    waCard.addEventListener('mouseenter', function() {
      this.style.borderColor = 'rgba(37,211,102,0.75)';
      this.style.boxShadow = '0 8px 40px rgba(37,211,102,0.2)';
    });
    waCard.addEventListener('mouseleave', function() {
      this.style.borderColor = 'rgba(37,211,102,0.4)';
      this.style.boxShadow = '0 4px 30px rgba(37,211,102,0.08)';
    });
  }

  // Sync select value to hidden subject field (for readable email subjects)
  var topikSelect = document.getElementById('ctc-topik');
  var subjectHidden = document.getElementById('ctc-subject-hidden');
  if (topikSelect && subjectHidden) {
    topikSelect.addEventListener('change', function() {
      subjectHidden.value = 'Kontak: ' + topikSelect.options[topikSelect.selectedIndex].text;
    });
  }
}

// ─── Privacy Policy Page ────────────────────────────────────
function initPrivacyPage() {
  if (!document.querySelector('.qbrix-privacy-section')) return;

  // Breadcrumbs stagger animation (10B pattern)
  document.querySelectorAll('.prv-breadcrumbs .crumb-anim').forEach(function(el) {
    el.classList.add('played');
  });

  // IntersectionObserver — 6B header
  var hdrObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('hdr-in-view');
        hdrObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.hdr-observe').forEach(function(el) {
    hdrObs.observe(el);
  });

  // IntersectionObserver — prv-reveal (scroll animations)
  var revealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('prv-in-view');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.prv-reveal').forEach(function(el, i) {
    el.style.transitionDelay = (i * 60) + 'ms';
    revealObs.observe(el);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initRefundPage();
  initShippingPage();
  initContactPage();
  initPrivacyPage();
});
